module.exports = __webpack_public_path__ + "img/11.bf64bb31.jpg";